import { connect } from 'react-redux';
import { withRouter } from 'utils/withRouter';
import ToolComponents from '../components';

const mapStateToProps = state => ({
  literals: state.i18n.literals.tool,
});

export default withRouter(connect(mapStateToProps)(ToolComponents));
